import { IconBetterspace } from "../../../features/layout/components/Icons";
import { useUIStore } from "../../store/useUIStore";

interface ProgressSpinner {
    className?: string;
}

const ProgressSpinner = (props: ProgressSpinner) => {
    const { className } = props;

    const { theme } = useUIStore();

    return (
        <div className={className}>
            <IconBetterspace animate type={theme} />
        </div>
    );
};

export default ProgressSpinner;
